module.exports = __webpack_public_path__ + "static/media/serena.fa5f8714.jpg";